import gql from 'graphql-tag';

export const loginTokenFragment = gql`{
  id
  
}`
